var map = {
	"./arrow.svg": "nCIC",
	"./behance-cover.svg": "9ybe",
	"./behance.svg": "n8B3",
	"./broken-img.svg": "v5mp",
	"./default-img.svg": "Effn",
	"./facebook-cover.svg": "uCgz",
	"./facebook.svg": "L+RT",
	"./footer-tiger-logo.svg": "ZeV3",
	"./instagram-cover.svg": "jNwU",
	"./instagram.svg": "JqR9",
	"./loading-ball.svg": "Z66p",
	"./red-cover.svg": "3xSL",
	"./red.svg": "E2K2",
	"./tiktok-cover.svg": "6LTd",
	"./tiktok.svg": "V3Y/",
	"./wechat-cover.svg": "fI4S",
	"./wechat.svg": "pYJ+",
	"./weibo-cover.svg": "1JzW",
	"./weibo.svg": "v1uz",
	"./welcome-button.svg": "QAsQ",
	"./welcome-logo.svg": "lsVd",
	"./welcome-logo2.svg": "dNuC",
	"./zcool-cover.svg": "aUag",
	"./zcool.svg": "HDK4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 8